import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHeaderResponse,
  HttpHeaders,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable, Component } from '@angular/core';
import { ApiEndPointsSettings } from '../../common/apiUrls/api-end-points-settings';
import { EnvService } from 'src/app/env.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject } from 'rxjs';
//import JSZip = require('jszip');
import * as FileSaver from 'file-saver';
import { Content } from '@angular/compiler/src/render3/r3_ast';
import * as JSZip from 'jszip';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
//import JSZip = require('jszip');

@Injectable({
  providedIn: 'root'
})
export class DownloadModel {
  link: string = '';
  fileSize: number = 0;
  fileName: string = '';
}

@Injectable({ providedIn: 'root' })
export class DownloadService {
  constructor(private httpClient: HttpClient,private toastr: ToastrService,
    private reusableClass: ReusableClasses,private encryptionAlgo: EncryptionService,
  ) {}

  async getFile(url: string) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    const httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type': this.getContentType(url),
        'Authorization': 'Bearer ' + token,
      }),
      responseType: 'blob',
    };
    const res = await this.httpClient
      .get<Content>(url, httpOptions)
      .toPromise()
      .catch((err: HttpErrorResponse) => {
        const error = err.error;
        return error;
      });
    return res;
  }

  async createZip(files: any[], zipName: string) {
    const zip = new JSZip();
    const name = zipName + '.zip';

    // tslint:disable-next-line:prefer-for-of
    for (let counter = 0; counter < files.length; counter++) {
      const element = files[counter];
      const fileData: any = await this.getFile(element);
      const b: any = new Blob([fileData], {
        type: fileData.type,
      });     

      zip.file(element.substring(element.lastIndexOf('/') + 1), b);
    }
    zip.generateAsync({ type: 'blob' }).then((content) => {
      if (content) {
        FileSaver.saveAs(content, name);
        this.toastr.success('Zip Download successfully', '', {
          timeOut: 3000,
         });     
      }
    });
  }

  getContentType(url: string): string {
    var extension = new RegExp(/(?:\.([^.]+))?$/).exec(url)[1];
    var contentType = '';

    switch (extension) {
      case 'pdf': {
        return 'application/pdf';
      }
      case 'xlsx': {
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      }
      case 'xsl': {
        return 'application/vnd.ms-excel';
      }
      case 'csv': {
        return 'application/vnd.ms-excel';
      }
      case 'jpg':{
        return 'image/jpg';
      }
      case 'jpge':{
        return 'image/jpge';
      }
      default: {
        return 'application/json-patch+json';
      }
    }
  }

  // downloadFile(data: Response) {
  //   const blob = new Blob([data], { type: 'application/octet-stream' });
  //   const url = window.URL.createObjectURL(blob);
  //   window.open(url);
  // }
}
